export function capitalizeWords(sentence) {
    if(!sentence) return '';
    return sentence
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  